<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'ModuleSubpageslistSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    description: ''
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Opis]]]')" :invalid-feedback="form.$errors.first('description')" :state="form.$errors.state('description')">
        <RichTextEditor id="description" v-model="form.settings.description" />
    </IdeoFormGroup>
</template>
